import React from 'react';
import './Cartescdq2.css';
import cdq1 from '../../Images/cdq photos/cdq1.jpg';
import cdq2 from '../../Images/cdq photos/cdq2.jpg';
import cdq3 from '../../Images/cdq photos/cdq3.jpg';
import cdq4 from '../../Images/cdq photos/cdq4.jpg';
import cdq5 from '../../Images/cdq photos/cdq5.jpg';
import cdq6 from '../../Images/cdq photos/cdq6.jpg';
import cdq7 from '../../Images/cdq photos/cdq7.jpg';
import cdq8 from '../../Images/cdq photos/cdq8.jpg';
import cdq9 from '../../Images/cdq photos/cdq9.jpg';

import cdq11 from '../../Images/cdq photos/cdq11.jpg';
import cdq12 from '../../Images/cdq photos/cdq12.jpg';
import cdq13 from '../../Images/cdq photos/cdq13.jpg';
import cdq14 from '../../Images/cdq photos/cdq14.jpg';
import cdq15 from '../../Images/cdq photos/cdq15.jpg';



const Cartescdq2 = () => {
    return (
        <div className="Cartescdq-container">
           

            <div className="cardscdq-container2">
                <div className="card1cdq">

                    <img src={cdq1} alt="" />
                </div>

                <div className="card2cdq1">
                    <img src={cdq2} alt="" />
                </div>

                <div className="card2cdq2">
                    <img src={cdq3} alt="" />
                </div>

                <div className="card2cdq3">
                    <img src={cdq4} alt="" />
                </div>

                <div className="card2cdq4">
                    <img src={cdq4} alt="" />
                </div>

                <div className="card2cdq5">
                    <img src={cdq5} alt="" />
                </div>

                <div className="card2cdq6">
                    <img src={cdq6} alt="" />
                </div>
                 
                <div className="card2cdq7">
                    <img src={cdq7} alt="" />
                </div>

                <div className="card2cdq8">
                    <img src={cdq8} alt="" />
                </div>
                
                <div className="card2cdq9">
                    <img src={cdq9} alt="" />
                </div>
                 
                
                  
                <div className="card2cdq11">
                    <img src={cdq11} alt="" />
                </div>
                   
                <div className="card2cdq12">
                    <img src={cdq12} alt="" />
                </div>
                     
                <div className="card2cdq13">
                    <img src={cdq13} alt="" />
                </div>  

                <div className="card2cdq14">
                    <img src={cdq14} alt="" />
                </div>
                <div className="card2cdq14">
                    <img src={cdq15} alt="" />
                </div>


            </div>
        </div>
        

    );
};

export default Cartescdq2;